/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pol_Page_TitleInputs */

const en_pol_page_title = /** @type {(inputs: Pol_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI provider policy`)
};

const id_pol_page_title = /** @type {(inputs: Pol_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kebijakan penyedia AI`)
};

/**
* | output |
* | --- |
* | "AI provider policy" |
*
* @param {Pol_Page_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const pol_page_title = /** @type {((inputs?: Pol_Page_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pol_Page_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_pol_page_title(inputs)
	return en_pol_page_title(inputs)
});